import { render, staticRenderFns } from "./UserTitle.vue?vue&type=template&id=73918072&"
import script from "./UserTitle?vue&type=script&lang=ts&"
export * from "./UserTitle?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports